import { ArrowLeft } from 'lucide-react'
import { WEBVIEW_HEADER_HEIGHT_PX } from 'shared/config/layout'
import { IconButton } from 'shared/ui/IconButton'
import { WebviewHeaderActionsSlot } from 'shared/ui/webviewHeaderActions'

interface WebviewHeaderProps {
  title: string
  onBack: () => void
}

export function WebviewHeader({ title, onBack }: WebviewHeaderProps) {
  const headerSurfaceClassName =
    'grid h-full w-full grid-cols-3 items-center border-b border-slate-200 bg-white px-3 text-slate-950 shadow-[0_4px_14px_rgb(15_23_42_/_6%)]'
  return (
    <header
      className="relative z-30 box-border w-full shrink-0"
      style={{ height: WEBVIEW_HEADER_HEIGHT_PX }}
    >
      <div className={headerSurfaceClassName}>
        <IconButton
          onClick={onBack}
          variant="ghost"
          size="md"
          className="justify-self-start text-slate-700"
          aria-label="Назад"
          title="Назад"
        >
          <ArrowLeft className="h-5 w-5" aria-hidden="true" />
        </IconButton>
        <div className="justify-self-center">
          <h1 className="truncate text-sm font-semibold uppercase text-slate-950">{title}</h1>
        </div>
        <WebviewHeaderActionsSlot className="justify-self-end" />
      </div>
    </header>
  )
}
